import './style.scss';

import { Modal } from 'antd';

import CloseOutlined from '../../../../assets/common/CloseOutlined';
import AppButton from '../../../../CommonComponents/UI/AppButton/AppButton';

const ViewWorkflow = ({ isOpen, data, onClose }) => {
  const extractionFields = data?.preset_prompt?.extractionFields;
  const extractionFieldsLength = data?.preset_prompt?.extractionFields?.length;

  return (
    <Modal
      open={isOpen}
      footer={null}
      width={820}
      onCancel={onClose}
      closeIcon={null}
      className='view-workflow-modal'
    >
      <header className='header mb-24'>
        <h2>{data?.preset_name}</h2>
        <AppButton type='text' onClick={onClose}>
          <CloseOutlined size={20} />
        </AppButton>
      </header>
      <ul className='fields-ul'>
        <li className='flex mb-16'>
          <p className='label'>Description</p>
          <p className='value'>{data?.preset_description}</p>
        </li>
        <li className='fs-18 fw-600 mb-16'>Prompt</li>
        <li className='flex mb-24'>
          <p className='label'>Persona & Task</p>
          <p className='value'>{data?.preset_prompt?.personaPrompt}</p>
        </li>
        <li className='flex'>
          <p className='label'>Extraction Fields</p>
          <ul className='extraction-fields-ul'>
            {extractionFields?.map((item, index) => (
              <li key={index} className='flex'>
                {extractionFieldsLength > 1 && (
                  <p className='index-count'>{String(index + 1).padStart(2, '0')}.</p>
                )}
                <div>
                  <div className='flex'>
                    <p className='label'>Extraction Field Name</p>
                    <span className='value'>{item?.extractionFieldName || '-'}</span>
                  </div>
                  <div className='flex'>
                    <p className='label'>Extraction Instruction</p>
                    <span className='value'>{item?.extractionInstruction || '-'}</span>
                  </div>
                  <div className='flex'>
                    <p className='label'>Output Type</p>
                    <span className='value'>{item?.outputType || '-'}</span>
                  </div>
                  <div className='flex'>
                    <p className='label'>Additional Output Fields</p>
                    {item?.additionalOutputFields?.length > 0 ? (
                      <ul className='additional-output-fields-ul'>
                        {item?.additionalOutputFields?.map((subItem, subIndex) => (
                          <li key={`${index}-${subIndex}`} className='flex'>
                            <p className='index-count'>{String(subIndex + 1).padStart(2, '0')}.</p>
                            <div>
                              <div className='flex'>
                                <p>Output Field Name</p>
                                <span className='value'>{subItem?.fieldName || '-'}</span>
                              </div>
                              <div className='flex'>
                                <p>Output Type</p>
                                <span className='value'>{subItem?.outputType || '-'}</span>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <span className='value'>-</span>
                    )}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </li>
      </ul>
    </Modal>
  );
};

export default ViewWorkflow;
